module.exports = __webpack_public_path__ + "img/AOD4.0a1ca72c.png";